module.exports = __webpack_public_path__ + "static/media/iq.e5d2e0c3.svg";